import { ReactElement, useContext, Context } from "react"

import Attachments from "./attachments"
import { Datasets } from "../../../../../constants/enums"
import useUploadDeviceAttachments from "../../../../../services/middleware/hooks/devices/common/useUploadDeviceAttachments"
import useUploadedDeviceAttachments from "../../../../../services/middleware/hooks/devices/common/useUploadedDeviceAttachments"
import { IDeviceFormContextValue } from "../../../types/providerTypes"
import { DeviceFormDataWithAttachments } from "../../types/providerTypes"

interface ILctAttachmentsProps<FormType> {
    context: Context<IDeviceFormContextValue<FormType>>
    dataset: Datasets
    isAmendment: boolean
}

/** Generic attachment upload form for LCTs - EVAC, EVDC and HP.
 *
 * Future TODO - also harmonise with TTR
 */
const LctDeviceAttachments = <FormType extends DeviceFormDataWithAttachments>({
    context,
    dataset,
    isAmendment,
}: ILctAttachmentsProps<FormType>): ReactElement => {
    const {
        currentIndex,
        setCurrentIndex,
        formData,
        setFormData,
        deviceId,
        deviceRef,
        saveDraft,
        saveDraftLoading,
        attachmentUUID,
    } = useContext(context)

    const {
        uploadAttachments,
        error: uploadError,
        loading: attachmentUploadInProgress,
    } = useUploadDeviceAttachments(
        deviceRef,
        deviceId,
        attachmentUUID,
        isAmendment
    )

    const {
        uploadedAttachments,
        error: listAttachmentsError,
        isLoading: isLoadingUploadedAttachments,
        error: uploadedAttachmentsError,
        mutate: updateUploadedAttachments,
    } = useUploadedDeviceAttachments(
        dataset,
        deviceRef,
        attachmentUUID,
        isAmendment
    )

    return (
        <Attachments<FormType>
            isLct
            dataset={dataset}
            isAmendment={isAmendment}
            currentIndex={currentIndex}
            setCurrentIndex={setCurrentIndex}
            formData={formData}
            setFormData={setFormData}
            deviceRef={deviceRef}
            saveDraft={saveDraft}
            saveDraftLoading={saveDraftLoading}
            attachmentUUID={attachmentUUID}
            uploadAttachments={uploadAttachments}
            attachmentUploadInProgress={attachmentUploadInProgress}
            uploadedAttachments={uploadedAttachments}
            isLoadingUploadedAttachments={isLoadingUploadedAttachments}
            uploadedAttachmentsError={uploadedAttachmentsError}
            updateUploadedAttachments={updateUploadedAttachments}
            listAttachmentsError={listAttachmentsError}
            uploadError={uploadError}
        />
    )
}

export default LctDeviceAttachments
